import { createAsyncThunk } from '@reduxjs/toolkit';
import { get, patchWithResponse } from '../models/base';

export const fetchPayouts = createAsyncThunk(
  'payouts/fetchPayouts',
  async (status, { rejectWithValue, getState }) => {
    const { pageNumber, perPage } = getState().payouts;

    try {
      const response = await get(
        `/api/payouts?page=${pageNumber}&per_page=${perPage}&payout_status=${status}`
      );
      return response;
    } catch (error) {
      return rejectWithValue({ error: error.message });
    }
  }
);

export const updatePayouts = createAsyncThunk(
  'payouts/updatePayouts',
  async (data, { rejectWithValue }) => {
    const { id, transactionStatus, transactionId } = data;

    const payoutData = {};

    if (transactionStatus) {
      payoutData.status = transactionStatus;
    }

    if (transactionId) {
      payoutData.transaction_id = transactionId;
    }

    try {
      const response = await patchWithResponse(
        `/api/payouts/${id}`,
        payoutData
      );
      return response;
    } catch (error) {
      return rejectWithValue({ error: error.message });
    }
  }
);

export const fetchTotalCredits = createAsyncThunk(
  'payouts/fetchTotalCredits',
  async (_, { rejectWithValue }) => {
    try {
      const response = await get(`/api/payouts/total_credited `);
      return response;
    } catch (error) {
      return rejectWithValue({ error: error.message });
    }
  }
);
